import type { GetStaticProps, NextPage } from 'next'
import { useTranslations } from 'next-intl'
import { NextSeo } from 'next-seo'

import { RegistrationPage } from '~modules/registration/pages/Registration.page'

// export const getServerSideProps: GetServerSideProps = async (ctx) => {
//   const lenguage: string = ctx.locale || 'es-MX'
//   const cookies = nookies.get(ctx)
//   const email = cookies.email
//   const queryClient = new QueryClient()

//   if (email) {
//     await queryClient.prefetchQuery(['evaluations', email], () => getEvaluation({ email }))
//     const evaluation = queryClient.getQueryData<Evaluation>(['evaluations', email])
//     if (evaluation?.state !== EvaluationStatus.STARTED) return redirectToResults()
//   }

//   return {
//     props: {
//       messages: (await import(`../locales/${lenguage}.js`)).default,
//       dehydratedState: dehydrate(queryClient),
//     },
//   }
// }

export const getStaticProps: GetStaticProps = async ({ locale = 'es-MX' }) => {
  return {
    props: {
      messages: (await import(`../locales/${locale}.js`)).default,
    },
  }
}

const RegistrationNextPage: NextPage = () => {
  const t = useTranslations('register')

  return (
    <>
      <NextSeo title={t('metaTitle')} description={t('metaDescription')} />
      <RegistrationPage />
    </>
  )
}

export default RegistrationNextPage
